import {
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material';

export const FormControlLabel = MuiFormControlLabel;
export type FormControlLabelProps = MuiFormControlLabelProps;
